const getHours = (totalHours = 12) => {
  const hours = new Array(totalHours);
  return Array.from(hours, (value, index) => {
    return { id: index + 1, name: (index + 1).toString() };
  });
};

export default getHours;
